import { ProductUnitType, productUnitTypes } from "@/apis/product";
import SText from "@/styles/SText";
import { Flex, Select, SelectProps } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface SProductUomProps extends SelectProps {
    value?: string;
    onChange?: (value: string) => void;
}

const ProductUomSelect = ({ value, onChange, }: SProductUomProps) => {

    const { t } = useTranslation();

    const [data, setdata] = useState<ProductUnitType[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)
        productUnitTypes()
            .then(types => {
                setdata(types)
                setLoading(false)
            })
            .catch(err => {
                setdata([])
                setLoading(false)
            })
    }, [])


    return <Select style={{ cursor: 'text' }} loading={loading}
        placeholder={t('product.plUom')}
        value={value}
        onChange={onChange}
        options={data.map(item => (
            {
                key: item.key,
                value: item.key,
                label: (
                    <Flex justify="space-between">
                        <SText text={item.key} />
                        <SText text={item.desc} style={{textAlign:'right'}} />
                    </Flex>
                )
            }
        ))}
    />
}
export default ProductUomSelect;